import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { RequestAccessComponent } from './components/request-access/request-access.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { REQUEST_ACCESS_FEATURE } from './store/request-access.state';
import { RequestAccessReducer } from './store/reducer/request-access.reducer';
import { RequestAccessEffects } from './store/effects/request-access.effects';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';


export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    RequestAccessComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    SGRESharedModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    StoreModule.forFeature(REQUEST_ACCESS_FEATURE, RequestAccessReducer),
    EffectsModule.forFeature(RequestAccessEffects),
    ConfigModule.withConfig({
      cmsComponents: {
        RequestAccessFormComponent: {
          component: () => import('./components/request-access/request-access.component').then(m => m.RequestAccessComponent),
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore }
  ]
})
export class RequestAccessModule { }